// extracted by mini-css-extract-plugin
export default {"root":"Contacts_root__Y9rtS","title":"Contacts_title__1mwVr"};